export enum ApiRoutesNoSlash {
            loads = 'loads',
            trucks = 'trucks'
}
